export const MODULE_ROUTE = {
  // App Info
  Root_Page: "*",
  Landing_Page: "*",
  Dashboard: "/",
  Logout: "/logout",
  Login: "/login",
  Link_Verify: "/verify/link/:link",
  FORGOT_PASSWORD: "/forgot/password",
  FORGOT_PASSWORD_6_DIGITS_CODE: "/forgot/password/6_digits",
  FORGOT_PASSWORD_NEW_PASSWORD: "/forgot/password/new",
  FORGOT_PASSWORD_SUCCESS: "/forgot/password/success",
};
